var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "722.000000pt",
    viewBox: "0 0 1280.000000 722.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,722.000000) scale(0.100000,-0.100000)",
    fill: "#555555",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6173 7205 c-159 -36 -179 -53 -1448 -1315 -406 -404 -1607 -1601 -2668 -2660 l-1929 -1925 -64 -127 -64 -128 0 -236 0 -236 41 -81 c110 -219 255 -363 444 -440 57 -23 95 -31 205 -39 92 -7 1928 -11 5815 -12 l5680 -1 59 23 c244 95 375 212 505 451 l51 94 0 239 0 238 -64 128 -64 127 -2024 2020 c-2529 2527 -3606 3596 -3729 3705 -181 160 -237 181 -504 186 -130 3 -197 0 -242 -11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort-up.4e05e346d4e1f8937fbd356b495bd4e9.svg";
export { ForwardRef as ReactComponent };